export function run(){
    return {
        featuredPropertiesSliderJquery(){
            let property_ct = $('.featured-properties .container-box .item').length;
            let property_width = $('.featured-properties .container-box .item').outerWidth(true);
            let box_width = $('.featured-properties .box-slide').outerWidth(true);
            let property_box_left = 0;
            let property_height = 0;
            $(window).on('resize load', function(){
                property_ct = $('.featured-properties .container-box .item').length;
                box_width = $('.featured-properties .box-slide').outerWidth(true);
                if(Math.floor(box_width / 296) != 0){
                    property_width = (box_width / Math.floor(box_width / 296)) - 36 + (36 / Math.floor(box_width / 296));
                }else{
                    property_width = box_width;
                }
                property_height = 0;
                $('.featured-properties .container-box .item').each(function(){
                    if($('.featured-properties .container-box .item').outerHeight(true) > property_height){
                        property_height = $('.featured-properties .container-box .item').outerHeight(true);
                    }
                });

                $('.featured-properties .container-box .item').width(property_width);
                $('.featured-properties .box-slide').height(property_height);
                $('.featured-properties .container-box').width((property_width + 36) * property_ct);
            });

            $('.featured-properties').on('click', '.box-slide-nav', function(){
                let property_box_left_new = property_box_left;
                if($(this).data('direction') == 'left'){
                    property_box_left_new -= property_width + 36; 
                }

                if($(this).data('direction') == 'right'){
                    property_box_left_new += property_width + 36; 
                }
                $('.featured-properties .box-slide-nav').removeClass('disabled');
                if(property_box_left_new > -1 * (property_width + 36)){
                    property_box_left_new = 0;
                    $('.featured-properties .box-slide-nav[data-direction="right"]').addClass('disabled');
                }
                
                if(Math.abs(property_box_left_new) + box_width >= (property_width + 36) * (property_ct - 1)){
                    if(Math.abs(property_box_left_new) + box_width >= (property_width + 36) * property_ct){
                        property_box_left_new = property_box_left;
                    }
                    $('.featured-properties .box-slide-nav[data-direction="left"]').addClass('disabled');
                }

                $('.featured-properties .container-box').animate({left: property_box_left_new}, 500);
                property_box_left = property_box_left_new;
            });
        },
        jquery(){
            $(function(){
                
            });
        }
    }
}
